import React from 'react';

export const AlertIcon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path d="M5.39,17.87H18.65c.37,0,1.22,0,1.51-.62s-.18-1.2-.83-2h0A5.8,5.8,0,0,1,17.68,12V8.09A5.88,5.88,0,0,0,12,2,5.87,5.87,0,0,0,6.28,8.09V12c0,1.2-1,2.34-1.69,3.22s-1,1.42-.74,2.05S4.82,17.87,5.39,17.87Z"/>
            <path d="M9.33,18.82a.48.48,0,0,0-.47.57,3.18,3.18,0,0,0,6.25,0,.49.49,0,0,0-.47-.57Z"/>
        </svg>
    )
}
